import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import useButtonStyles from './Button.Styles';
export const DefaultProps = {
    color: 'primary',
    size: 'm',
    variant: 'solid',
    disabled: false,
    rounded: true,
    fullWidth: true
};
// Component
export const Button = ({ variant, disabled, rounded, fullWidth, iconLeft, iconRight, sx, children, ...props }) => {
    const theme = useTheme();
    const selectedVariant = (variant ??= DefaultProps.variant);
    const isDisabled = (disabled ??= DefaultProps.disabled);
    const isRounded = (rounded ??= DefaultProps.rounded);
    const { [selectedVariant]: variantStyle, ...styles } = useButtonStyles({
        ...{ rounded: isRounded, fullWidth, ...props },
        theme
    });
    return (_jsxs("button", { className: `${styles.base} ${variantStyle} ${isDisabled ? styles.disabled : ''} ${props.size === 'xl' ? styles.xl : ''}`, disabled: isDisabled, ...props, style: sx, children: [iconLeft && _jsx("div", { className: styles.iconLeft, children: iconLeft }), children, iconRight && _jsx("div", { className: styles.iconRight, children: iconRight })] }));
};
export default Button;
